import React, { useEffect, useState, useRef, lazy } from 'react';
const previewPages = [{
  src: 'https://cdn.magicpatterns.com/uploads/rmBmyM4TPKjtgbdrzyHiY3/Captura-de-pantalla-2026-05-27-a-las-4.31.22_p.-m..webp',
  tag: 'Esercizio Risolto',
  title: 'Calcolo della Densità',
  vol: 'Vol. 1 — Grandezze'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1omsjVQYJG2Ey9vK8FP1za/Captura-de-pantalla-2026-05-27-a-las-4.32.27_p.-m..webp',
  tag: 'Teoria + Applicazione',
  title: "Primo Principio di Newton: l'Inerzia",
  vol: 'Vol. 2 — Meccanica'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/221ZY75eKgAqV5vvG4zyxU/Captura-de-pantalla-2026-05-27-a-las-4.33.00_p.-m..webp',
  tag: 'Esercizio Risolto',
  title: 'Il Facchino — Calcolo del Lavoro',
  vol: 'Vol. 3 — Energia'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/dcsFKMiThh2dtgM4187A9C/Captura-de-pantalla-2026-05-27-a-las-4.34.29_p.-m..webp',
  tag: 'Approfondimento',
  title: 'Analisi del Primo Principio: I Segni',
  vol: 'Vol. 4 — Termodinamica'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3f99pv2GZUYqTxHptDwtmx/Captura-de-pantalla-2026-05-27-a-las-4.35.40_p.-m..webp',
  tag: 'Esercizio Guidato',
  title: 'La Legge dei Punti Coniugati',
  vol: 'Vol. 5 — Onde e Ottica'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2sutiMjyCgEsP2YKAkZ4C7/Captura-de-pantalla-2026-05-27-a-las-4.39.41_p.-m..webp',
  tag: 'Teoria + Formula',
  title: 'Il Campo Elettrico: Modificazione dello Spazio',
  vol: 'Vol. 6 — Elettromagnetismo'
}];
export function VolumesDetail() {
  const fisicaVols = [{
    vol: '⚡ Vol. 1',
    content: 'Grandezze e Vettori — Fondamenta, misure e incertezza.'
  }, {
    vol: '⚡ Vol. 2',
    content: 'Meccanica — Equilibrio, Moto e Leggi di Newton.'
  }, {
    vol: '⚡ Vol. 3',
    content: 'Energia e Gravitazione — Lavoro, conservazione e leggi celesti.'
  }, {
    vol: '⚡ Vol. 4',
    content: 'Termodinamica — Calore, temperatura e leggi dei gas.'
  }, {
    vol: '⚡ Vol. 5',
    content: 'Onde e Ottica — Suono, luce e fenomeni ondulatori.'
  }, {
    vol: '⚡ Vol. 6',
    content: 'Elettromagnetismo — Circuiti, campi e accenni di fisica moderna.'
  }];
  const bookEmojis = ['📘', '📗', '📕', '📙', '📘', '📙'];
  const formatVolText = (volText: string) => {
    return volText + ':';
  };
  const scrollerRef = useRef<HTMLDivElement | null>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollToIndex = (idx: number) => {
    const el = scrollerRef.current;
    if (!el) return;
    const child = el.children[idx] as HTMLElement | undefined;
    if (!child) return;
    el.scrollTo({
      left: child.offsetLeft - el.offsetLeft,
      behavior: 'smooth'
    });
  };
  const handleScroll = () => {
    const el = scrollerRef.current;
    if (!el) return;
    const center = el.scrollLeft + el.clientWidth / 2;
    let best = 0;
    let bestDist = Infinity;
    Array.from(el.children).forEach((c, i) => {
      const node = c as HTMLElement;
      const childCenter = node.offsetLeft - el.offsetLeft + node.clientWidth / 2;
      const d = Math.abs(childCenter - center);
      if (d < bestDist) {
        bestDist = d;
        best = i;
      }
    });
    setActiveIndex(best);
  };
  useEffect(() => {
    const el = scrollerRef.current;
    if (!el) return;
    el.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => el.removeEventListener('scroll', handleScroll);
  }, []);
  const prev = () => scrollToIndex(Math.max(0, activeIndex - 1));
  const next = () => scrollToIndex(Math.min(previewPages.length - 1, activeIndex + 1));
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border" data-id="element-281">
      <div className="max-w-5xl mx-auto" data-id="element-282">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-white mb-16" data-id="element-283">
          Cosa ricevi in <span className="text-[#00FF84]" data-id="element-284">FISICA PRONTA</span>
        </h2>
        <div className="max-w-2xl mx-auto flex flex-col gap-8 mb-20" data-id="element-285">
          <div className="bg-brand-card border border-brand-accent/40 rounded-2xl p-6 md:p-8" data-id="element-286">
            <div className="mb-6" data-id="element-287">
              <h3 className="text-xl md:text-2xl font-heading font-bold uppercase mb-1 text-[#00FF84]" data-id="element-288">
                ⚡ 6 Volumi Didattici (PDF Alta Qualità)
              </h3>
              <p className="text-white/70 text-sm" data-id="element-289">
                Per docenti di Fisica della scuola secondaria
              </p>
            </div>
            <div className="space-y-5" data-id="element-290">
              {fisicaVols.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-291">
                  <span className="text-xl leading-none mt-0.5" data-id="element-292">
                    {bookEmojis[i]}
                  </span>
                  <p className="text-white/90 text-base leading-relaxed" data-id="element-293">
                    <span className="font-bold text-white mr-1" data-id="element-294">
                      {formatVolText(item.vol)}
                    </span>
                    {item.content}
                  </p>
                </div>)}
            </div>
          </div>
        </div>

        {/* Material Preview Carousel */}
        <div className="max-w-5xl mx-auto" data-id="element-295">
          <div className="text-center mb-8 md:mb-10" data-id="element-296">
            <div className="inline-flex items-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-xs md:text-sm uppercase mb-3" data-id="element-297">
              <span aria-hidden="true" data-id="element-298">👀</span>
              <span data-id="element-299">Sbircia dentro</span>
            </div>
            <h3 className="text-2xl md:text-4xl font-heading font-black text-white leading-tight mb-3" data-id="element-300">
              Guarda <span className="text-brand-accent" data-id="element-301">cosa c'è dentro</span>
            </h3>
            <p className="text-white/70 text-sm md:text-base max-w-xl mx-auto" data-id="element-302">
              Pagine reali dei volumi — lezioni, esercizi risolti e
              approfondimenti pronti da usare in aula.
            </p>
          </div>

          {/* Carousel */}
          <div className="relative" data-id="element-303">
            {/* Edge fade — desktop */}
            <div className="hidden md:block pointer-events-none absolute inset-y-0 left-0 w-12 bg-gradient-to-r from-brand-dark to-transparent z-10" aria-hidden="true" data-id="element-304" />
            <div className="hidden md:block pointer-events-none absolute inset-y-0 right-0 w-12 bg-gradient-to-l from-brand-dark to-transparent z-10" aria-hidden="true" data-id="element-305" />

            {/* Prev/Next buttons — desktop */}
            <button onClick={prev} disabled={activeIndex === 0} aria-label="Pagina precedente" className="hidden md:flex absolute left-2 top-1/2 -translate-y-1/2 z-20 w-11 h-11 rounded-full bg-brand-card border border-brand-border text-white items-center justify-center hover:bg-brand-accent hover:text-brand-dark hover:border-brand-accent transition-colors disabled:opacity-30 disabled:pointer-events-none" data-id="element-306">
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-307">
                <polyline points="15 18 9 12 15 6" data-id="element-308" />
              </svg>
            </button>
            <button onClick={next} disabled={activeIndex === previewPages.length - 1} aria-label="Pagina successiva" className="hidden md:flex absolute right-2 top-1/2 -translate-y-1/2 z-20 w-11 h-11 rounded-full bg-brand-card border border-brand-border text-white items-center justify-center hover:bg-brand-accent hover:text-brand-dark hover:border-brand-accent transition-colors disabled:opacity-30 disabled:pointer-events-none" data-id="element-309">
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-310">
                <polyline points="9 18 15 12 9 6" data-id="element-311" />
              </svg>
            </button>

            {/* Scrolling track */}
            <div ref={scrollerRef} className="flex gap-4 md:gap-6 overflow-x-auto snap-x snap-mandatory scroll-smooth pb-4 -mx-4 px-4 md:mx-0 md:px-12 scrollbar-hide" style={{
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
          }} data-id="element-312">
              {previewPages.map((page, i) => <article key={i} className="snap-center flex-shrink-0 w-[78vw] sm:w-[60vw] md:w-[340px] lg:w-[360px]" data-id="element-313">
                  <div className="bg-brand-card border border-brand-border rounded-2xl overflow-hidden h-full flex flex-col hover:border-brand-accent/60 transition-colors" data-id="element-314">
                    {/* Page image */}
                    <div className="relative bg-white aspect-[3/4] overflow-hidden" data-id="element-315">
                      <img src={page.src} alt={`Anteprima pagina: ${page.title}`} loading="lazy" className="w-full h-full object-cover object-top" data-id="element-316" />
                      {/* Tag overlay */}
                      <div className="absolute top-3 left-3 bg-brand-accent text-brand-dark font-black text-[10px] md:text-xs uppercase tracking-widest px-2.5 py-1 rounded-full shadow-md" data-id="element-317">
                        {page.tag}
                      </div>
                    </div>
                    {/* Caption */}
                    <div className="p-4 md:p-5" data-id="element-318">
                      <div className="text-brand-accent font-badge font-bold tracking-widest text-[10px] md:text-xs uppercase mb-1.5" data-id="element-319">
                        {page.vol}
                      </div>
                      <h4 className="text-white font-heading font-black text-base md:text-lg leading-tight" data-id="element-320">
                        {page.title}
                      </h4>
                    </div>
                  </div>
                </article>)}
            </div>
          </div>

          {/* Dots */}
          <div className="flex items-center justify-center gap-2 mt-2" data-id="element-321">
            {previewPages.map((_, i) => <button key={i} onClick={() => scrollToIndex(i)} aria-label={`Vai alla pagina ${i + 1}`} aria-current={activeIndex === i} className={`transition-all rounded-full ${activeIndex === i ? 'bg-brand-accent w-8 h-2' : 'bg-white/25 hover:bg-white/50 w-2 h-2'}`} data-id="element-322" />)}
          </div>

          {/* Page counter */}
          <p className="text-center text-white/50 text-xs md:text-sm mt-3 font-medium" data-id="element-323">
            <span className="text-white font-bold" data-id="element-324">{activeIndex + 1}</span>
            <span className="mx-1" data-id="element-325">/</span>
            <span data-id="element-326">{previewPages.length}</span>
            <span className="ml-2 text-white/40" data-id="element-327">
              — Esempi reali dei 6 volumi
            </span>
          </p>
        </div>
      </div>
    </section>;
}